/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orchestrate_The_Primary_MessagInputs */

const en_orchestrate_the_primary_messag = /** @type {(inputs: Orchestrate_The_Primary_MessagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orchestrate the primary messaging and cinematic staging.`)
};

const es_orchestrate_the_primary_messag = /** @type {(inputs: Orchestrate_The_Primary_MessagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orquesta el mensaje principal y la exposición cinematográfica.`)
};

const fr_orchestrate_the_primary_messag = /** @type {(inputs: Orchestrate_The_Primary_MessagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orchestrez le message principal et la mise en scène cinématique.`)
};

const de_orchestrate_the_primary_messag = /** @type {(inputs: Orchestrate_The_Primary_MessagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orchestriere die Hauptbotschaft und die filmische Inszenierung.`)
};

const ja_orchestrate_the_primary_messag = /** @type {(inputs: Orchestrate_The_Primary_MessagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主要なメッセージングとシネマティックな演出を調整します。`)
};

const zh_orchestrate_the_primary_messag = /** @type {(inputs: Orchestrate_The_Primary_MessagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精心策划核心信息传递与视觉展示。`)
};

const ar_orchestrate_the_primary_messag = /** @type {(inputs: Orchestrate_The_Primary_MessagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نسّق الرسالة الأساسية والعرض السينمائي.`)
};

const id_orchestrate_the_primary_messag = /** @type {(inputs: Orchestrate_The_Primary_MessagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orkestrasi pesan utama dan pementasan sinematik.`)
};

const it_orchestrate_the_primary_messag = /** @type {(inputs: Orchestrate_The_Primary_MessagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci il messaggio principale e la presentazione cinematografica.`)
};

const ru_orchestrate_the_primary_messag = /** @type {(inputs: Orchestrate_The_Primary_MessagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управляйте главным сообщением и визуальным представлением.`)
};

const pt_orchestrate_the_primary_messag = /** @type {(inputs: Orchestrate_The_Primary_MessagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orquestre a mensagem principal e a exposição cinematográfica.`)
};

const ko_orchestrate_the_primary_messag = /** @type {(inputs: Orchestrate_The_Primary_MessagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주요 메시지와 시네마틱 연출을 기획하세요.`)
};

/**
* | output |
* | --- |
* | "Orchestrate the primary messaging and cinematic staging." |
*
* @param {Orchestrate_The_Primary_MessagInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const orchestrate_the_primary_messag = /** @type {((inputs?: Orchestrate_The_Primary_MessagInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orchestrate_The_Primary_MessagInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orchestrate_the_primary_messag(inputs)
	if (locale === "es") return es_orchestrate_the_primary_messag(inputs)
	if (locale === "fr") return fr_orchestrate_the_primary_messag(inputs)
	if (locale === "de") return de_orchestrate_the_primary_messag(inputs)
	if (locale === "ja") return ja_orchestrate_the_primary_messag(inputs)
	if (locale === "zh") return zh_orchestrate_the_primary_messag(inputs)
	if (locale === "ar") return ar_orchestrate_the_primary_messag(inputs)
	if (locale === "id") return id_orchestrate_the_primary_messag(inputs)
	if (locale === "it") return it_orchestrate_the_primary_messag(inputs)
	if (locale === "ru") return ru_orchestrate_the_primary_messag(inputs)
	if (locale === "pt") return pt_orchestrate_the_primary_messag(inputs)
	return ko_orchestrate_the_primary_messag(inputs)
});